export default __webpack_public_path__ + "static/media/help-rav-inv-17.8938996a.png";